import { selectAllStrings } from '../language/languageSlice';
import { selectLatestNews, fetchLatestNews } from './newsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import NewsList from './NewsList';

const NewsSection = () => {
    const strings = useSelector(selectAllStrings);
    const news = useSelector(selectLatestNews);
    const newsStatus = useSelector((state) => state.news.status);
    const newsError = useSelector((state) => state.news.error);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (newsStatus === 'idle') {
            dispatch(fetchLatestNews());
        }
    }, [newsStatus, dispatch]);
    
    return <div className="news">
            <h2>{strings.latest_news}</h2>
            <NewsList news={news.slice(0, 5)} status={newsStatus} error={newsError}/>
        </div>
};

export default NewsSection;